import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'clsx';
import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';
import IconDownload from '~/components/svg/download.svg';

@withI18next()
class ButtonDownloadPhoto extends React.Component {
  render() {
    const { t, onClick, isPremium, loading } = this.props;
    const downloadButtonClassName = classNames(
      'btn',
      `btn-${Config.serviceType}`,
      'btn-block',
      'btn-download',
    );
    // let buttonText = isPremium ? t('Download') : t('free_download');
    let buttonText = t('Download');

    if (Config.isDesignAC()) {
      buttonText += ' (*.zip)';
    }

    return (
      <button className={downloadButtonClassName} onClick={onClick}>
        {loading ? (
          <FontAwesomeIcon
            style={{ marginRight: 16, width: 24 }}
            icon={faSpinner}
            pulse
          />
        ) : (
          <IconDownload style={{ width: 20, marginRight: 16 }} />
        )}
        {buttonText}
        <style jsx>
          {`
            .btn-download {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              height: 48px;
              border-radius: 4px;
              font-size: 16px;
              color: #fff;
              font-weight: 600;
              margin-top: 16px;
              background: #1b2833;
            }
            .btn-download:hover {
              color: #fff;
              background: ${themeVariables.colors.primary};
            }
          `}
        </style>
      </button>
    );
  }
}

export default ButtonDownloadPhoto;
